import './index.styl';
import template from './index.jst';
import { CoreAccountSettingsView } from '../../../../../core/views';

export default class AccountSettings extends CoreAccountSettingsView {
	get template() {
		return template;
	}

	get team_name_key() {
		return 'team_name';
	}

	get className() {
		return 'account-settings shadow';
	}
}